"use strict";
const { object, string, array } = require('../../utils/modifiedYup');
const { displayComponentSchema, formComponentSchema, } = require('../../commonSteps/componentSchema');
const rawContentSchema = object().shape({
    type: string().oneOf(['raw']).required(),
    subject: string(),
    body: string().required(),
});
const displayComponentContentSchema = object().shape({
    type: string().oneOf(['component']),
    subject: string(),
    components: array(displayComponentSchema).min(1).required(),
});
const formComponentContentSchema = object().shape({
    type: string().oneOf(['component']),
    subject: string(),
    components: array(object().oneOfSchemas([displayComponentSchema, formComponentSchema])).required(),
});
const templateContentSchema = object().shape({
    type: string().oneOf(['template']),
    iuxId: string().required(),
});
const builderContentSchema = object().shape({
    type: string().oneOf(['builder-content']).required(),
    contentId: string().uuid().required(),
    activationId: string().uuid(),
});
module.exports = {
    rawContentSchema,
    displayComponentContentSchema,
    templateContentSchema,
    formComponentContentSchema,
    builderContentSchema,
};
//# sourceMappingURL=contentSchema.js.map